import { getOhaById } from 'api/oha';
import { useMutation, useQuery } from 'react-query';
import {
  getMutationApplication,
  getTechnicalProductsForConvertLoan,
  saveMutationApplication,
  submitMutationApplication,
  submitCollateralApplication,
  CollateralData,
} from 'api/mutations';
import { ApplicationReadDto, ConversionMutationApplication } from '__generated__/api';

export function useSaveMutation(onSuccess: (data: any) => void, onError: (error: any) => void) {
  return useMutation(
    (formData: ConversionMutationApplication) => saveMutationApplication(formData),
    {
      onSuccess,
      onError,
    }
  );
}

export function useSubmitMutation(onSuccess: (result: any) => void, onError: (error: any) => void) {
  return useMutation((formData: ApplicationReadDto) => submitMutationApplication(formData), {
    onSuccess,
    onError,
  });
}

export function useSubmitCollateral(
  onSuccess: (result: any) => void,
  onError: (error: any) => void
) {
  return useMutation((formData: CollateralData) => submitCollateralApplication(formData), {
    onSuccess,
    onError,
  });
}

export const useGetMutationApplication = (id = 0) => {
  return useQuery(['get-mutation-application'], () => getMutationApplication(id), {
    enabled: false,
  });
};

export const useOhaMutation = (id = 0) => {
  return useQuery(['get-oha-by-id', id], () => getOhaById(id), {
    enabled: id !== 0,
  });
};

export const useGetTechnicalProducts = (commercialLabel: string, loanNumber: number) => {
  return useQuery(['get-technical-products', commercialLabel, loanNumber], () =>
    getTechnicalProductsForConvertLoan(commercialLabel, loanNumber)
  );
};
